import { IGcpAppDispatch } from "../../../redux/store";
import { IStoreState } from "../../../redux/rootReducer";
import { IGcpAppIo } from "../../../redux/io";
import { SIDEBAR_OPENED } from "../../../tracking/constants";
import { toggleSidebarVisibility } from "../../../redux/modules/modePilotUi/reducer";

const userClicksSidebarVisibilityControl =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(SIDEBAR_OPENED);
    dispatch(toggleSidebarVisibility());
  };

export default userClicksSidebarVisibilityControl;
